/**
 * en-GB messages added by Phase 2 task S13B (docs/PHASE-2-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s13bEnGB = {
    'error.prearrival_disabled': 'This part of the pre-arrival page is not switched on.',
    'error.prearrival_closed': 'This visit can no longer be changed.',
    'error.prearrival_time': 'Please choose a time in the next 60 days.',
    'error.prearrival_notice': 'That notice is not one of the notices for this visit.',
    'error.prearrival_signature': 'This notice needs a signature.',
    'error.prearrival_car': 'Please enter a valid registration.',
    'email.pre-registration.host.rescheduled.subject': '{name} has changed their visit to {site}',
    'email.pre-registration.host.rescheduled.body': '{name} has moved their visit to {site} to {date} at {time}.',
    'email.pre-registration.host.cancelled.subject': '{name} has cancelled their visit to {site}',
    'email.pre-registration.host.cancelled.body': '{name} has cancelled their visit to {site} on {date} at {time}.',
    'email.pre-registration.host.message': 'Message from the visitor: {message}',
};
//# sourceMappingURL=s13b.js.map